import React, { ReactNode, useRef } from 'react'
import { useGetPosition } from '../utils/useGetPosition'
import './style.scss'
import { useHover } from 'shared/lib/hooks/useHover'
import { onStopPropagationHandler } from 'shared/lib/hooks/onStopPropagationHandler'

interface AppTooltipProps {
  className?: string
  children: ReactNode | string
  tooltipContent: ReactNode | string
}

export const AppTooltip = ({
  className,
  children,
  tooltipContent,
}: AppTooltipProps) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const refContent = useRef<HTMLDivElement | null>(null)
  const [isHover, hoverFnBind] = useHover()
  const position = useGetPosition(ref, isHover)
  const contentPosision = refContent?.current?.getBoundingClientRect()
  const getTop = () => {
    if (!contentPosision) return position.top
    if (position.top < contentPosision?.height + 80) {
      return position.top + contentPosision?.height + 40
    } else {
      return position.top - 12
    }
  }
  return (
    <div className={`tooltipWrap ${className}`} ref={ref} {...hoverFnBind}>
      {children}
      {isHover && (
        <div
          className="tooltipContent"
          ref={refContent}
          style={{
            top: getTop(),
            left: position.left + position.width / 2,
          }}
          onClick={onStopPropagationHandler}
        >
          {tooltipContent}
          <div
            className="corner"
            style={{
              display:
                position.top <
                (contentPosision ? contentPosision?.height + 80 : 0)
                  ? 'none'
                  : 'block',
            }}
          />
        </div>
      )}
    </div>
  )
}
